import IamApi from "api/IamApi";
import { EMPTY, IN_PROGRESS, ERROR } from "constants/Status";
import { useBiller, usePaymentHistory } from "hooks";
import { Spinner } from "kubra-ux-forge";
import _ from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  matchPath,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import routing from "routing";
import { getBillerLoadStatus } from "selectors";
import { ISession } from "types/session";
import { getDomain, mapSessionLanguageToUiLanguage } from "utilities/helper";
import { useTranslation } from "react-i18next";
import { getDeviceFingerprint } from "selectors/appState";

export const Payment = () => {
  const fingerprint = useSelector(getDeviceFingerprint);
  const { loadBiller, getBiller } = useBiller();
  const loadBillerStatus = useSelector(getBillerLoadStatus);
  const biller = getBiller();
  const { login } = useOutletContext<ISession>();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const maxRecentPayments = 3;

  const getBillerConfiguration = () => {
    loadBiller();
  };

  const { loadRecentPayments, loadUpcomingPayment } = usePaymentHistory();

  const getPaymentId = () => {
    const match = matchPath(routing.payment.read(":id"), location.pathname);
    return _.get(match, ["params", "id"]);
  };

  const queryParams = new URLSearchParams(location.search);

  const accountId = queryParams.get("AccountId");
  const language = queryParams.get("Language");
  const instanceId = queryParams.get("InstanceId");
  const spaceKrn = queryParams.get("SpaceKrn");
  const accountKrn = queryParams.get("AccountKrn");
  const hash = queryParams.get("hash");

  useEffect(() => {
    const loadBillerAndPayments = async () => {
      const paymentId = getPaymentId();
      if (biller === null || biller === undefined) {
        getBillerConfiguration();
      } else if (biller && paymentId && fingerprint) {
        let directlandingsucess = false;

        if (accountId && instanceId && hash && language) {
          const paymentRequest = {
            accountId: accountId,
            hash: hash,
          };
          await IamApi.ezpay
            .getPayment({
              deviceFingerprint: fingerprint,
              userAgent: navigator.userAgent,
              domain: getDomain(),
              instanceId,
              paymentId,
              language,
              clientId: biller.clientId,
              paymentRequest,
            })
            .then((paymentResponse) => {
              //handle success
              console.log("direct landing success");
              directlandingsucess = true;
              login(paymentResponse.data);
              const selectedLanguage = mapSessionLanguageToUiLanguage(
                language ?? "en"
              );
              i18n.changeLanguage(selectedLanguage);
            })
            .catch((error) => {
              console.log(error);
              navigate(routing.index());
            });
        } else if (accountKrn && spaceKrn && hash && language) {
          const paymentRequest = {
            accountKrn: accountKrn,
            hash: hash,
          };
          await IamApi.ezpay
            .getPaymentV2({
              deviceFingerprint: fingerprint,
              userAgent: navigator.userAgent,
              domain: getDomain(),
              spaceKrn,
              paymentId,
              language,
              clientId: biller.clientId,
              paymentRequest,
            })
            .then((paymentResponse) => {
              //handle success
              console.log("direct landing success");
              directlandingsucess = true;
              login(paymentResponse.data);
              const selectedLanguage = mapSessionLanguageToUiLanguage(
                language ?? "en"
              );
              i18n.changeLanguage(selectedLanguage);
            })
            .catch((error) => {
              console.log(error);
              navigate(routing.index());
            });
        }

        if (directlandingsucess) {
          try {
            console.log("Navigation to recent payment");
            await Promise.all([
              loadRecentPayments(
                maxRecentPayments,
                biller.clientId,
                biller.realm
              ),
              loadUpcomingPayment(biller.clientId, biller.realm),
            ]);
            navigate(routing.recentPayments.index());
          } catch (error) {
            console.log("Error loading recent payments:", error);
            navigate(routing.index());
          }
        } else navigate(routing.index());
      } else navigate(routing.index());
    };

    loadBillerAndPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [biller, fingerprint]);

  if (
    loadBillerStatus === EMPTY ||
    loadBillerStatus === IN_PROGRESS ||
    loadBillerStatus === ERROR
  ) {
    if (loadBillerStatus === ERROR) {
      console.log("failed to retrieve instance");
    }

    return (
      <div className="validate-frame">
        <div className="validate-content">
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    );
  }

  return <></>;
};

export default Payment;
